/**
 * Calculate the number of nights between check-in and check-out dates.
 *
 * @param checkInDate - The check-in date in ISO string format (YYYY-MM-DD)
 * @param checkOutDate - The check-out date in ISO string format (YYYY-MM-DD)
 * @returns {number} - The number of nights between the dates
 */
export const calculateNights = (checkInDate?: string, checkOutDate?: string): number => {
	if (!checkInDate || !checkOutDate) {
		return 0;
	}

	const checkIn = new Date(checkInDate);
	const checkOut = new Date(checkOutDate);

	// Validate dates
	if (isNaN(checkIn.getTime()) || isNaN(checkOut.getTime())) {
		return 0;
	}

	// Calculate the difference in milliseconds
	const diffInMs = checkOut.getTime() - checkIn.getTime();

	// Convert milliseconds to days
	const nights = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

	// Return 0 if the result is negative (checkout before checkin)
	return Math.max(0, nights);
};
